import BottomSheetContent from '../../BottomSheetContent'
import { convertEpochToDate } from '../../../../utils/utils'

type WhyNotSIPBottomSheetProps = {
  nextSIPDate: number
  whyNotSIPDate: number
  onClose: () => void
}

export const WhyNotSIPBottomSheet = ({ nextSIPDate, whyNotSIPDate, onClose }: WhyNotSIPBottomSheetProps) => {
  return (
    <BottomSheetContent
      heading={`Why ${convertEpochToDate(nextSIPDate, '%d %b')} instead of ${convertEpochToDate(
        whyNotSIPDate,
        '%d %b'
      )}?`}
      bottomSheetHeadingClassName='text-[#232323] !font-[500] !mb-2'
      onDismiss={onClose}
    >
      <div className='text-[#6A6E6E] text-[14px] font-[400] leading-[150%]'>
        There needs to be a 30-day gap between your 1st and 2nd SIP. That’s why your 2nd SIP is scheduled for the month
        after.
      </div>
    </BottomSheetContent>
  )
}
